import { render, staticRenderFns } from "./precistDelivery.vue?vue&type=template&id=09f135f0&"
import script from "./precistDelivery.vue?vue&type=script&lang=js&"
export * from "./precistDelivery.vue?vue&type=script&lang=js&"
import style0 from "./precistDelivery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports